export default __webpack_public_path__ + "static/media/blueTransparentEye.3ff0d15b.svg";